(() => {
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (reducedMotion || !('IntersectionObserver' in window)) return;

  const reveal = () => {
    const sections = document.querySelectorAll('#MainContent > .shopify-section:not(.juke-observed)');
    const observer = new IntersectionObserver((entries, currentObserver) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        entry.target.animate(
          [
            { opacity: 0.01, transform: 'translateY(24px)' },
            { opacity: 1, transform: 'translateY(0)' }
          ],
          { duration: 650, easing: 'cubic-bezier(.2,.7,.2,1)', fill: 'none' }
        );
        currentObserver.unobserve(entry.target);
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });

    sections.forEach((section) => {
      section.classList.add('juke-observed');
      observer.observe(section);
    });
  };

  requestAnimationFrame(reveal);
  document.addEventListener('shopify:section:load', reveal);
})();
